import script from "./AdvanceCourseComp.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvanceCourseComp.vue?vue&type=script&setup=true&lang=js"

import "./AdvanceCourseComp.vue?vue&type=style&index=0&id=61a9eafb&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a9eafb"]])

export default __exports__